The details of the `Candidate` to be uploaded.
